<div class="nutrition-popup" (offClick)="clickedOutside()">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
      <h1>Nutrition & Allergen Information</h1>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 text-left bdr-rgt">
      <p>Total Calories</p>
      <b>{{nutritionInfo.calories}}</b>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 text-left bdr-rgt">
      <p>Total Fat (g)</p>
      <b>{{nutritionInfo.totalFat}}</b>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 text-left">
      <p>Total Carbs (g)</p>
      <b>{{nutritionInfo.carbs}}</b>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
      <h2>Nutrition</h2>
      <hr/>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
      <ul class="pull-left">
        <li>
          <p>Weight (g)</p>
          <b>{{nutritionInfo.weight}}</b>
        </li>
        <li>
          <p>Calories</p>
          <b>{{nutritionInfo.calories}}</b>
        </li>
        <li>
          <p>Calories from Fat</p>
          <b>{{nutritionInfo.caloriesFromFat}}</b>
        </li>
        <li>
          <p>Saturated Fat (g)</p>
          <b>{{nutritionInfo.saturatedFat}}</b>
        </li>
        <li>
          <p>Trans Fat (g)</p>
          <b>{{nutritionInfo.transFat}}</b>
        </li>
        <li>
          <p>Cholesterol (g)</p>
          <b>{{nutritionInfo.cholesterol}}</b>
        </li>
        <li>
          <p>Sodium (mg)</p>
          <b>{{nutritionInfo.sodium}}</b>
        </li>
      </ul>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
      <ul class="pull-left">
        <li>
          <p>Dietary Fiber (g)</p>
          <b>{{nutritionInfo.dietaryFiber}}</b>
        </li>
        <li>
          <p>Protein (g)</p>
          <b>{{nutritionInfo.protein}}</b>
        </li>
        <li>
          <p>Sugars (g)</p>
          <b>{{nutritionInfo.sugars}}</b>
        </li>
      </ul>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <h2>Allergens</h2>
      <hr class="mg-btm-10"/>
      <ul class="allergens-list">
        <ng-container *ngFor="let item of allergens">
          <li>
            <img alt="allergens icon" src="../assets/images/order/alrgn_{{item.slug?.toLowerCase()}}.png" /> {{item.name}}
          </li>
        </ng-container>
      </ul>
      <div class="allergens-text">
        <p class="line-breaker">Whataburger does not operate allergen-free kitchens or restaurants. Our foods are prepared in restaurants and supplied from facilities that use shared equipment and processing lines, and as a result, menu items may contain or come into contact with major food allergens through cross-contact, even when not intentionally added.          
        </p>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="ingredientDesc">
    <div class="panel-group" id="accordion">
      <div class="panel-heading">
        <h2 class="panel-title collapsed" data-toggle="collapse" data-parent="#accordion" href="#ingredients">
          <a class="accordion-toggle">Ingredients</a>
        </h2>
        <hr class="mg-btm-0"/>
      </div>
      <div id="ingredients" class="panel-collapse collapse">
        <div class="panel-body">
          <p class="line-breaker">{{ ingredientDesc }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
